import groupBy from 'lodash/groupBy'
import sumBy from 'lodash/sumBy'
import mapValues from 'lodash/mapValues'
import keys from 'lodash/keys'

export default function (serviceSummaries) {
  const groupedSummaries = groupBy(serviceSummaries, 'areaTypeName')
  
  const withCounts = mapValues(groupedSummaries, summary => 
    mapValues(groupBy(summary, 'serviceName'), service => ({
      quantity: sumBy(service, 'quantity'),
      aggregatedQuantity: sumBy(service, 'aggregatedQuantity')
    }))
  )

  return keys(withCounts).map(areaTypeName => ({
    areaTypeName,
    services: withCounts[areaTypeName]
  }))
}



// WEBPACK FOOTER //
// ./src/helpers/count-services-in-summaries.js